// removed by extract-text-webpack-plugin
module.exports = {"commentHeader":"_2ikzD","search":"FLV8d","commentAvatar":"UZ0Uc","commentTime":"Pqu7S","withMoreButton":"_1M89s","moreButton":"_2DYEs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment-header/comment-header.scss
// module id = 1118
// module chunks = 0 3 5